export { Loader } from '@mantine/core'